import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'react-loadable';
import Loader from '../Loader';
const Loading = ({ size }) => _jsx(Loader, { size: size }, void 0);
//*** EQUIPMENT GROUPS *** //
const IconAccessTransportation = Loadable({
    loader: () => import('../../icons/Equipment/AccessTransportation'),
    loading: Loading,
});
const IconHVAC = Loadable({
    loader: () => import('../../icons/Equipment/Hvac'),
    loading: Loading,
});
const IconItOfficeAv = Loadable({
    loader: () => import('../../icons/Equipment/ItOfficeAv'),
    loading: Loading,
});
const IconLighting = Loadable({
    loader: () => import('../../icons/Equipment/Lighting'),
    loading: Loading,
});
const IconRefrigeration = Loadable({
    loader: () => import('../../icons/Equipment/Refrigeration'),
    loading: Loading,
});
const IconSelfService = Loadable({
    loader: () => import('../../icons/Equipment/SelfService'),
    loading: Loading,
});
const IconFoodHolding = Loadable({
    loader: () => import('../../icons/Equipment/FoodHolding'),
    loading: Loading,
});
const IconFoodProcessing = Loadable({
    loader: () => import('../../icons/Equipment/FoodProcessing'),
    loading: Loading,
});
const IconGeneric = Loadable({
    loader: () => import('../../icons/Equipment/Generic'),
    loading: Loading,
});
//*** EQUIPMENT TYPES ***//
const IconElevator = Loadable({
    loader: () => import('../../icons/Equipment/AccessTransportationElevator'),
    loading: Loading,
});
const IconPlug = Loadable({
    loader: () => import('../../icons/Equipment/GenericPlug'),
    loading: Loading,
});
const IconAirCurtainUnit = Loadable({
    loader: () => import('../../icons/Equipment/HvacAirCurtainUnit'),
    loading: Loading,
});
const IconAirHandler = Loadable({
    loader: () => import('../../icons/Equipment/HvacAirHandler'),
    loading: Loading,
});
const IconBoiler = Loadable({
    loader: () => import('../../icons/Equipment/HvacBoiler'),
    loading: Loading,
});
const IconCirculationFan = Loadable({
    loader: () => import('../../icons/Equipment/HvacCirculationFan'),
    loading: Loading,
});
const IconExhaustAirUnit = Loadable({
    loader: () => import('../../icons/Equipment/HvacExhaustAirUnit'),
    loading: Loading,
});
const IconHeater = Loadable({
    loader: () => import('../../icons/Equipment/HvacHeater'),
    loading: Loading,
});
const IconDehumidifier = Loadable({
    loader: () => import('../../icons/Equipment/HvacDehumidifier'),
    loading: Loading,
});
const IconRooftopUnit = Loadable({
    loader: () => import('../../icons/Equipment/HvacRooftopUnit'),
    loading: Loading,
});
const IconSplitCompressor = Loadable({
    loader: () => import('../../icons/Equipment/HvacSplitCompressor'),
    loading: Loading,
});
const IconVavUnit = Loadable({
    loader: () => import('../../icons/Equipment/HvacVavUnit'),
    loading: Loading,
});
const IconVentilationFan = Loadable({
    loader: () => import('../../icons/Equipment/HvacVentilationFan'),
    loading: Loading,
});
const IconComputer = Loadable({
    loader: () => import('../../icons/Equipment/ItOfficeAvComputer'),
    loading: Loading,
});
const IconDisplay = Loadable({
    loader: () => import('../../icons/Equipment/ItOfficeAvDisplay'),
    loading: Loading,
});
const IconNetworkEquipment = Loadable({
    loader: () => import('../../icons/Equipment/ItOfficeAvNetworkEquipment'),
    loading: Loading,
});
const IconPhoneSystem = Loadable({
    loader: () => import('../../icons/Equipment/ItOfficeAvPhoneSystem'),
    loading: Loading,
});
const IconProjector = Loadable({
    loader: () => import('../../icons/Equipment/ItOfficeAvProjector'),
    loading: Loading,
});
const IconAmbientLighting = Loadable({
    loader: () => import('../../icons/Equipment/LightingAmbientLighting'),
    loading: Loading,
});
const IconWalkInFreezer = Loadable({
    loader: () => import('../../icons/Equipment/RefrigerationWalkInFreezer'),
    loading: Loading,
});
const IconFreezer = Loadable({
    loader: () => import('../../icons/Equipment/RefrigerationFreezer'),
    loading: Loading,
});
const IconIceMachine = Loadable({
    loader: () => import('../../icons/Equipment/RefrigerationIceMachine'),
    loading: Loading,
});
const IconRefrigerator = Loadable({
    loader: () => import('../../icons/Equipment/RefrigerationRefrigerator'),
    loading: Loading,
});
const IconWalkInCooler = Loadable({
    loader: () => import('../../icons/Equipment/RefrigerationWalkInCooler'),
    loading: Loading,
});
const IconAtm = Loadable({
    loader: () => import('../../icons/Equipment/SelfServiceAtm'),
    loading: Loading,
});
const IconBeverageDispenser = Loadable({
    loader: () => import('../../icons/Equipment/SelfServiceBeverageDispenser'),
    loading: Loading,
});
const IconFuelDispenser = Loadable({
    loader: () => import('../../icons/Equipment/SelfServiceFuelDispenser'),
    loading: Loading,
});
const IconAutomatedPaymentMachines = Loadable({
    loader: () => import('../../icons/Equipment/SelfServiceAutomatedPaymentMachines'),
    loading: Loading,
});
//General logic of this is:
//if available, display equipmentType icon
//if no equipmentType icon, display equipmentGroup icon
//if no equipmentGroup icon, then display generic icon
const IconEquipmentFactory = ({ classes, size, id }) => {
    switch (id) {
        case 'equipmentSelfServiceEquipment': // Group
        case 'equipmentTicketMachine':
        case 'equipmentVendingMachine':
            return _jsx(IconSelfService, { classes: classes, size: size }, void 0);
        case 'equipmentAtm':
            return _jsx(IconAtm, { classes: classes, size: size }, void 0);
        case 'equipmentFuelDispenser':
            return _jsx(IconFuelDispenser, { classes: classes, size: size }, void 0);
        case 'equipmentBeverageDispenser':
            return _jsx(IconBeverageDispenser, { classes: classes, size: size }, void 0);
        case 'equipmentAutomatedPaymentMachines':
            return _jsx(IconAutomatedPaymentMachines, { classes: classes, size: size }, void 0);
        case 'equipmentLighting': // Group
        case 'equipmentCanopyLighting':
        case 'equipmentSignage':
        case 'equipmentFacadeLighting':
        case 'equipmentLandscapeLighting':
        case 'equipmentStreetParkingLighting':
        case 'equipmentEntertainmentLighting':
        case 'equipmentEmergencyLighting':
        case 'equipmentAccentLighting':
        case 'equipmentTaskLighting':
            return _jsx(IconLighting, { classes: classes, size: size }, void 0);
        case 'equipmentAmbientLighting':
            return _jsx(IconAmbientLighting, { classes: classes, size: size }, void 0);
        case 'equipmentAccessTransportation': // Group
        case 'equipmentAccessTransportationDoor':
        case 'equipmentTurnstile':
        case 'equipmentGate':
        case 'equipmentBarrier':
        case 'equipmentEscalator':
            return _jsx(IconAccessTransportation, { classes: classes, size: size }, void 0);
        case 'equipmentElevator':
            return _jsx(IconElevator, { classes: classes, size: size }, void 0);
        case 'equipmentItOfficeAv': // Group
        case 'equipmentUninterruptiblePowerSupply':
        case 'equipmentDataCenterStorage':
        case 'equipmentServer':
        case 'equipmentAudioSystem':
        case 'equipmentCopierScannerPrinter':
            return _jsx(IconItOfficeAv, { classes: classes, size: size }, void 0);
        case 'equipmentPhoneSystem':
            return _jsx(IconPhoneSystem, { classes: classes, size: size }, void 0);
        case 'equipmentProjector':
            return _jsx(IconProjector, { classes: classes, size: size }, void 0);
        case 'equipmentDisplay':
            return _jsx(IconDisplay, { classes: classes, size: size }, void 0);
        case 'equipmentComputer':
            return _jsx(IconComputer, { classes: classes, size: size }, void 0);
        case 'equipmentNetworkEquipment':
            return _jsx(IconNetworkEquipment, { classes: classes, size: size }, void 0);
        case 'equipmentHvac': // Group
        case 'equipmentAirConditioner':
        case 'equipmentBlower':
        case 'equipmentHeatPump':
        case 'equipmentPortableHvacUnit':
        case 'equipmentMakeupAirUnit':
        case 'equipmentFanCoilUnit':
        case 'equipmentVrvVrfCompressor':
        case 'equipmentChiller':
        case 'equipmentPackagedSplitUnit':
        case 'equipmentUnitaryPackagedUnit':
            return _jsx(IconHVAC, { classes: classes, size: size }, void 0);
        case 'equipmentDehumidifier':
            return _jsx(IconDehumidifier, { classes: classes, size: size }, void 0);
        case 'equipmentAirCurtainUnit':
            return _jsx(IconAirCurtainUnit, { classes: classes, size: size }, void 0);
        case 'equipmentCirculationFan':
            return _jsx(IconCirculationFan, { classes: classes, size: size }, void 0);
        case 'equipmentVentilationFan':
            return _jsx(IconVentilationFan, { classes: classes, size: size }, void 0);
        case 'equipmentExhaustAirUnit':
            return _jsx(IconExhaustAirUnit, { classes: classes, size: size }, void 0);
        case 'equipmentHeater':
            return _jsx(IconHeater, { classes: classes, size: size }, void 0);
        case 'equipmentAirHandler':
            return _jsx(IconAirHandler, { classes: classes, size: size }, void 0);
        case 'equipmentSplitCompressor':
            return _jsx(IconSplitCompressor, { classes: classes, size: size }, void 0);
        case 'equipmentBoiler':
            return _jsx(IconBoiler, { classes: classes, size: size }, void 0);
        case 'equipmentVavUnit':
            return _jsx(IconVavUnit, { classes: classes, size: size }, void 0);
        case 'equipmentRooftopUnit':
            return _jsx(IconRooftopUnit, { classes: classes, size: size }, void 0);
        case 'equipmentRefrigeration': // Group
        case 'equipmentBlastChillers':
        case 'equipmentRefrigeratedShelf':
        case 'equipmentRefrigeratedDisplayCase':
        case 'equipmentReachInRefrigerator':
            return _jsx(IconRefrigeration, { classes: classes, size: size }, void 0);
        case 'equipmentIceMachine':
            return _jsx(IconIceMachine, { classes: classes, size: size }, void 0);
        case 'equipmentWalkInCooler':
            return _jsx(IconWalkInCooler, { classes: classes, size: size }, void 0);
        case 'equipmentWalkInFreezer':
            return _jsx(IconWalkInFreezer, { classes: classes, size: size }, void 0);
        case 'equipmentFreezer':
            return _jsx(IconFreezer, { classes: classes, size: size }, void 0);
        case 'equipmentRefrigerator':
            return _jsx(IconRefrigerator, { classes: classes, size: size }, void 0);
        case 'equipmentFoodHolding': // Group
        case 'equipmentColdFoodHolding':
        case 'equipmentPrepTable':
        case 'equipmentHeatLamp':
        case 'equipmentSoupwell':
        case 'equipmentHeatedDisplayCase':
        case 'equipmentHotFoodHoldingCabinet':
        case 'equipmentFoodWarmer':
            return _jsx(IconFoodHolding, { classes: classes, size: size }, void 0);
        case 'equipmentFoodProcessing': // Group
        case 'equipmentSlicer':
        case 'equipmentFoodProcessor':
        case 'equipmentJuicer':
        case 'equipmentBlender':
        case 'equipmentShakeMachine':
        case 'equipmentIceCreamMachine':
        case 'equipmentMincer':
        case 'equipmentMixer':
        case 'equipmentMicrowave':
        case 'equipmentCoffeeMachine':
        case 'equipmentCooker':
        case 'equipmentGrill':
        case 'equipmentSalamander':
        case 'equipmentOven':
        case 'equipmentCharbroiler':
        case 'equipmentGriddles':
        case 'equipmentFryers':
            return _jsx(IconFoodProcessing, { classes: classes, size: size }, void 0);
        case 'equipmentVehicleCharger': // Group
        case 'equipmentForkliftCharger':
        case 'equipmentEBikeCharger':
        case 'equipmentCarCharger':
            return _jsx(IconGeneric, { classes: classes, size: size }, void 0);
        case 'equipmentAppliances': // Group
        case 'equipmentDishwasher':
        case 'equipmentWashingMachine':
        case 'equipmentHandDryer':
        case 'equipmentDryer':
            return _jsx(IconGeneric, { classes: classes, size: size }, void 0);
        case 'equipmentEnergyGenerator': // Group
        case 'equipmentChpGenerator':
        case 'equipmentWindGenerator':
        case 'equipmentSolarGenerator':
            return _jsx(IconGeneric, { classes: classes, size: size }, void 0);
        case 'equipmentWaterTreatment': // Group
        case 'equipmentFilter':
        case 'equipmentWaterHeater':
        case 'equipmentWaterSoftener':
            return _jsx(IconGeneric, { classes: classes, size: size }, void 0);
        case 'equipmentGeneric': // Group
            return _jsx(IconGeneric, { classes: classes, size: size }, void 0);
        case 'equipmentPlug':
            return _jsx(IconPlug, { classes: classes, size: size }, void 0);
        case 'equipmentPumpsCompressors': // Group
        case 'equipmentValve':
        case 'equipmentCompressor':
        case 'equipmentPump':
            return _jsx(IconGeneric, { classes: classes, size: size }, void 0);
        default:
            return _jsx(IconGeneric, { classes: classes, size: size }, void 0);
    }
};
export default IconEquipmentFactory;
